import { LoginForm } from '../types';

import { axios } from '@/lib/axios';

export const APIlogin = (data: LoginForm): Promise<string> => {
    return axios.post('/auth/sign-in', data);
};
